import React, { Fragment, useEffect } from 'react'
import Img1 from "../images/checked.png"
import Img2 from "../images/pending-approval.png"
import Img3 from "../images/logo-black.png"
import Img4 from "../images/logo.png"
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadUserAction, LogoutUserAction } from '../../redux/actions/userActions'


const PendingApproval = ({ setShowSupport }) => {


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isLoggedout, user, isAuthenticated } = useSelector(
        (state) => state.verifyEmailStore
    );



    useEffect(() => {
        if (isLoggedout) {
            localStorage.setItem("email", "");
            navigate("/login");
        }

        if (user?.status === "PENDING_APPROVAL") {
            navigate("/pending-approval")
        } else {
            navigate("/")
        }


    }, [isLoggedout, navigate, isAuthenticated, user]);



    const handleRefresh = () => {


        console.log()

        dispatch(loadUserAction());
    }


      const logoutUser = () => {
        dispatch(LogoutUserAction());
      };


    return (
        <Fragment>
            <div className="min-h-screen bg-[#f6f8fc] text-slate-950 dark:bg-[#0b1220] dark:text-white flex flex-col overflow-hidden">
                
                {/* Header/Logo */}
                <div className="w-full px-5 py-4 sm:px-8 sm:py-6">
                    <div className="mx-auto flex w-full max-w-7xl items-center justify-between">
                        <Link to="/pending-approval/" aria-label="Zonify Pro" className="inline-flex">
                            <img src={Img3} alt="Zonify Pro" className="h-8 w-auto object-contain dark:hidden sm:h-9" />
                            <img src={Img4} alt="Zonify Pro" className="hidden h-8 w-auto object-contain dark:block sm:h-9" />
                        </Link>
                    </div>
                </div>

                {/* Main Content */}
                <main className="flex-1 flex items-center px-5 py-8 sm:px-8 lg:py-10">
                    <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-8 md:gap-10 lg:grid-cols-[1fr_0.95fr] lg:gap-14">
                        
                        {/* Left Column: Text Content */}
                        <div className="mx-auto w-full max-w-xl space-y-5 text-center sm:space-y-6 lg:mx-0 lg:text-left">
                            <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center sm:gap-3 lg:justify-start">
                                <h1 className="text-[2.3rem] font-bold leading-[1.05] tracking-tight text-slate-950 dark:text-white sm:text-5xl lg:text-[3.35rem]">
                                    Your account is<br className="hidden sm:block" /> under review
                                </h1>
                                <img src={Img1} alt="" className="h-11 w-11 shrink-0 object-contain sm:h-12 sm:w-12" />
                            </div>

                            <p className="mx-auto max-w-lg text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base lg:mx-0">
                                Your account has been successfully created and is currently awaiting approval.
                                Our team is reviewing your information to ensure a secure and trusted platform for everyone.
                            </p>

                            {/* Info Box */}
                            <div className="mx-auto flex max-w-lg items-start gap-3 rounded-2xl border border-emerald-300/70 bg-emerald-50 p-4 text-left shadow-sm shadow-emerald-900/5 dark:border-emerald-300/60 dark:bg-emerald-400/10 dark:shadow-none sm:items-center sm:gap-4">
                                <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-400/15 dark:text-emerald-300">
                                    <i className="fa-regular fa-clock text-base"></i>
                                </div>
                                <div className="min-w-0">
                                    <h3 className="text-sm font-semibold text-emerald-950 dark:text-emerald-200">This usually takes up to 24 hours.</h3>
                                    <p className="mt-1 text-xs font-semibold text-emerald-700 dark:text-emerald-300">
                                        You'll be notified once your account is approved.
                                    </p>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex flex-col gap-3 pt-1 sm:flex-row sm:justify-center lg:justify-start">
                                <Link to="/add-user-details/" className="inline-flex min-h-11 items-center justify-center rounded-xl bg-slate-950 px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-colors hover:bg-slate-800 dark:bg-sky-400 dark:text-slate-950 dark:hover:bg-sky-300 dark:shadow-sky-950/20">
                                    Review Details
                                </Link>

                                <button
                                    onClick={() => setShowSupport(true)}
                                    className="inline-flex min-h-11 items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition-colors hover:bg-slate-50 dark:border-sky-400/35 dark:bg-slate-900/70 dark:text-slate-100 dark:hover:border-sky-300/60 dark:hover:bg-slate-800"
                                >
                                    Contact Support
                                </button>
                            </div>
                        </div>

                        {/* Right Column: Illustration */}
                        <div className="mx-auto flex w-full max-w-sm justify-center md:max-w-md lg:max-w-lg">
                            <img src={Img2} alt="Pending approval illustration" className="w-full object-contain drop-shadow-[0_24px_50px_rgba(15,23,42,0.16)] dark:drop-shadow-[0_24px_50px_rgba(0,0,0,0.35)]" />
                        </div>
                    </div>
                </main>

                {/* Footer */}
                <footer className="border-t border-slate-200 bg-white/80 px-5 py-4 text-xs text-slate-500 backdrop-blur dark:border-slate-800 dark:bg-slate-950/45 dark:text-slate-300 sm:px-8">
                    <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-4 sm:flex-row">
                        <div className="text-center sm:text-left">
                        © Zonifypro 2026. All rights reserved
                        </div>
                        <div className="grid w-full grid-cols-2 gap-3 sm:flex sm:w-auto sm:items-center">
                            <button
                                onClick={() => handleRefresh()}
                                className="min-h-10 rounded-xl bg-slate-100 px-4 py-2 font-bold text-slate-700 transition-colors hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
                            >
                                Refresh
                            </button>
                            <button 
                                className="min-h-10 rounded-xl bg-red-600 px-4 py-2 font-bold text-white transition-colors hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600"
                                onClick={logoutUser}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </footer>
            </div>
        </Fragment>
    )
}

export default PendingApproval
